<template>
  <div class="coucher-container">
    <div class="title">
      <span>订购记录</span>
    </div>
    <div class="box">
      <div v-if="!orderList.length" class="not-order">暂无订购内容</div>
      <div
        v-for="(item, index) in orderList"
        :key="index"
        class="list"
      >
        <van-row class="row-list" type="flex" justify="space-between" align="center">
          <van-col class="t" :span="5">订购分类</van-col>
          <van-col class="name" :span="17">{{item.type_name}}</van-col>
        </van-row>
        <van-row class="row-list" type="flex" justify="space-between" align="center">
          <van-col class="t" :span="5">订购型号</van-col>
          <van-col class="name" :span="17">{{item.type_no}}</van-col>
        </van-row>
        <van-row class="row-list" type="flex" justify="space-between" align="center">
          <van-col class="t" :span="5">时间</van-col>
          <van-col class="name" :span="17">{{item.order_time}}</van-col>
        </van-row>
        <van-row class="row-list" type="flex" justify="space-between" align="center">
          <van-col class="t" :span="5">支付金额</van-col>
          <van-col class="name" :span="17">{{item.pay}}</van-col>
        </van-row>
        <van-row class="row-list" type="flex" justify="space-between" align="center">
          <van-col class="t" :span="5">姓名</van-col>
          <van-col class="name" :span="17">{{item.name}}</van-col>
        </van-row>
        <van-row class="row-list" type="flex" justify="space-between" align="center">
          <van-col class="t" :span="5">所在省份</van-col>
          <van-col class="name" :span="17">{{item.province}}</van-col>
        </van-row>
        <van-row class="row-list" type="flex" justify="space-between" align="center">
          <van-col class="t" :span="5">所在城市</van-col>
          <van-col class="name" :span="17">{{item.city}}</van-col>
        </van-row>
        <van-row class="row-list" type="flex" justify="space-between" align="center">
          <van-col class="t" :span="5">所在区县</van-col>
          <van-col class="name" :span="17">{{item.county}}</van-col>
        </van-row>
        <van-row class="row-list" type="flex" justify="space-between" align="center">
          <van-col class="t" :span="5">手机</van-col>
          <van-col class="name" :span="17">{{item.phone | formatPhoneNumber}}</van-col>
        </van-row>
        <!-- <van-row class="row-lists" type="flex" justify="space-between" align="center" style="margin-top: 8px;">
          <van-col class="t" :span="7">经销商名称</van-col>
          <van-col class="name" :span="15">{{item.distributor_name}}</van-col>
        </van-row> -->
        <van-row class="row-lists" type="flex" justify="space-between" align="center">
          <van-col class="t" :span="7">商品名称</van-col>
          <van-col class="name" :span="15">{{item.product_name}}</van-col>
        </van-row>
        <van-row class="row-lists" type="flex" justify="space-between" align="center">
          <!-- <van-col class="t" :span="5">简介</van-col> -->
          <van-col class="name" :span="24" v-html="item.product_desc"></van-col>
        </van-row>
      </div>
      <div v-if="orderList.length" class="button">请截图保存</div>
      <div class="footer">最终解释权归当地经销商所有</div>
    </div>
  </div>
</template>
<script>
import * as api from "@/api/live";
import { formatIsoToDateStart } from "@/utils/utils.js";
export default {
  props: ['userId', 'live_id', 'hasToPAyCount', 'orderList'],
  data() {
    return {
      // couchers: []
    }
  },
  filters: {
    formatPhoneNumber(phone) {
      // console.log('phone',phone);
      if (!phone || phone.length !== 11) return phone
      return phone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
    }
  },
  watch: {
    // hasToPAyCount(val) {
    //   console.log('订单更新val----', val)
    //   this.initVouchers()
    //   this.$nextTick(() => {
    //     this.$emit('hasOrder', this.couchers && this.couchers.length > 0)
    //   })
    // },
    orderList(newVal) {
      // 实时给父组件传递是否有订单的状态
      this.$emit('hasOrder', newVal && newVal.length > 0);
    }
  },
  created() {
    // this.initVouchers()
  },
  methods: {
    // initVouchers() {
    //   const data = { user_id: this.userId, live_id: this.live_id }
		// 	api.myorders(data).then((res) => {
    //     console.log('我的订单列表', res)
		// 		if (res.code === 200) {
		// 			this.couchers = res.result.map(item => ({
    //         ...item,
    //         order_time: formatIsoToDateStart(item.order_time)
    //       }))
		// 		}
    //     console.log('订单接口', this.couchers)
    //     this.$emit('hasOrder', this.couchers && this.couchers.length > 0)
		// 	})
    // },
  },
}
</script>
<style lang="less" scoped>
  .coucher-container{
    font-size: 14px;
    background-color: #3db8c6;
    padding: 16px;
    .title{
      position: relative;
      margin: 0 10px;
      padding-top: 4px;
      &::before{
        content: '';
        width: calc(100% + 20px);
        height: 8px;
        background-color: #2197a4;
        border-radius: 4px;
        position: absolute;
        z-index: 0;
        top: 0;
        left: -10px;
      }
      span{
        position: relative;
        z-index: 1;
        display: block;
        background-color: #fff;
        border: solid 1px #12656e;
        font-size: 14px;
        color: #212121;
        text-align: center;
        line-height: 34px;
      }
    }
    .box{
      position: relative;
      z-index: 1;
      margin: 0 10px;
      background-color: #fff;
      font-size: 14px;
      margin-bottom: 6px;
      .list{
        position: relative;
        padding: 28px 20px 20px;
        border-top: dashed 1px #d8d8d8;
        &::before,
        &::after{
          content: '';
          position: absolute;
          top: -8px;
          width: 16px;
          height: 16px;
          border-radius: 16px;
          background-color: #3db8c6;
        }
        &::before{
          left: -8px;
        }
        &::after{
          right: -8px;
        }
        .row-list{
          min-height: 34px;
        }
        .t{
          color: #686868;
          text-align-last: justify;
        }
      }
      .footer{
        background-image: url(data:image/jpeg;base64,/9j/4QAYRXhpZgAASUkqAAgAAAAAAAAAAAAAAP/sABFEdWNreQABAAQAAAA8AAD/4QMraHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wLwA8P3hwYWNrZXQgYmVnaW49Iu+7vyIgaWQ9Ilc1TTBNcENlaGlIenJlU3pOVGN6a2M5ZCI/PiA8eDp4bXBtZXRhIHhtbG5zOng9ImFkb2JlOm5zOm1ldGEvIiB4OnhtcHRrPSJBZG9iZSBYTVAgQ29yZSA1LjMtYzAxMSA2Ni4xNDU2NjEsIDIwMTIvMDIvMDYtMTQ6NTY6MjcgICAgICAgICI+IDxyZGY6UkRGIHhtbG5zOnJkZj0iaHR0cDovL3d3dy53My5vcmcvMTk5OS8wMi8yMi1yZGYtc3ludGF4LW5zIyI+IDxyZGY6RGVzY3JpcHRpb24gcmRmOmFib3V0PSIiIHhtbG5zOnhtcD0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wLyIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bXA6Q3JlYXRvclRvb2w9IkFkb2JlIFBob3Rvc2hvcCBDUzYgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjQwNEUzQkMxMUE4QjExRjBCN0Y0RUQ5MjU2MTE2QThDIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjQwNEUzQkMyMUE4QjExRjBCN0Y0RUQ5MjU2MTE2QThDIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6NDA0RTNCQkYxQThCMTFGMEI3RjRFRDkyNTYxMTZBOEMiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NDA0RTNCQzAxQThCMTFGMEI3RjRFRDkyNTYxMTZBOEMiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz7/7gAOQWRvYmUAZMAAAAAB/9sAhAAGBAQEBQQGBQUGCQYFBgkLCAYGCAsMCgoLCgoMEAwMDAwMDBAMDg8QDw4MExMUFBMTHBsbGxwfHx8fHx8fHx8fAQcHBw0MDRgQEBgaFREVGh8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx//wAARCAAGACQDAREAAhEBAxEB/8QAegAAAgMAAAAAAAAAAAAAAAAAAAQFBgcBAAIDAQAAAAAAAAAAAAAAAAADAgQFBhAAAAUDAgQHAAAAAAAAAAAAAQISAwQAEQUhB6ETFAbRomSkFVYnEQACAQMDAAsAAAAAAAAAAAABAgARAwQhUaFhcRJSYqITI1MUJP/aAAwDAQACEQMRAD8A1H9U9Z5a1PY6JyX7/FJrtuduFF6jrcY9kVo5fOfbYRZV7KAVKvwpN1bRpQ0l7Du5iV7SF+sgUiWaf3LfyTzsaLJhsmSiM24R0pbEABscug3HWp2xZA1IMRktnM5KhlG1QeYYV/ctjJMuyYsmYyVS4zjhGimuQQC5zaBYdaLgskaECGM2crgsGYbVA5lo+c7x+s++Y8Krenb7/Bmp9nJ+HzrP/9k=);
        background-position: 0 100%;
        background-repeat: repeat-x;
        background-size: auto;
        position: relative;
        padding: 12px 0;
        text-align: center;
        color: #c6c6c6;
        bottom: -5px;
      }
      .button{
        margin: 20px auto;
        width: 80%;
        height: 34px;
        line-height: 34px;
        text-align: center;
        color: #fff;
        background-color: #007aff;
        border-radius: 4px;
      }
    }
    .not-order{
      text-align: center;
      padding: 30px 0;
      color: #666;
      font-size: 14px;
    }
    .row-lists{
      background-color: #f6f6f6;
      padding: 8px;
      .t{
        text-align-last: left
      }
      .name{
        text-align: left;
      }
    }
  }
</style>